<template>
  <div class="campsite-detail-faq" :class="{ desktop: $isDesktop }">
    <translate tag="h2"> Frequently asked questions </translate>
    <article data-allow-mismatch v-html="faq" />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CampsiteDetailFaq extends Vue {
  @Prop()
  faq: string
}

export default toNative(CampsiteDetailFaq)
</script>
<style scoped>
.campsite-detail-faq {
  padding: 1em 1.4em;
}

h2 {
  font-weight: normal;
  color: var(--colour-dark-blue);
}

article {
  border-bottom: 4px solid var(--colour-page-background);
  color: var(--colour-dark-blue);
  font-size: var(--body);
  padding: 1em 0;
  width: 100%;
}

article :deep(.question) {
  font-weight: bold;
  font-size: 1.15em;
}

article :deep(.question),
article :deep(.answer) {
  display: block;
  margin-top: 0.25em;
}

article :deep(.campsite-faq li) {
  margin: 0 0 1.75em;
}

article :deep(.arrive_depart_table tr) {
  border-color: var(--colour-table-borders);
}

article :deep(a) {
  color: var(--colour-dark-blue);
}

article :deep(.answer li) {
  margin: 0 0 0.25em;
}

article :deep(.answer li a),
article :deep(.answer li a:active),
article :deep(.answer li a:visited) {
  display: inline-block;
  font-weight: normal;
}

article :deep(.answer a),
article :deep(.answer a:active),
article :deep(.answer a:visited) {
  font-weight: bold;
  text-decoration: underline;
  margin-top: 0.25em;
  display: block;
}

.desktop.campsite-detail-faq {
  padding: 1em 0;
}
</style>
